
import { RevCard } from '@ds/components/Card'
import isEmpty from 'lodash/isEmpty'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './SellerDescription.constants'
import translations from './SellerDescription.translations'

export default {
  components: {
    RevCard,
  },

  props: {
    seller: {
      type: Object,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,

    sellerAddress() {
      const {
        company,
        street,
        street2,
        city,
        country,
        postal_code: postalCode,
      } = this.seller.address

      // TODO: The address should come from the back-end
      // Depending on the country the format could be different.
      // Ticket: NS-676
      return [company, street, street2, postalCode, city, country]
        .filter(Boolean)
        .join(', ')
    },

    japanSellerAddress() {
      const {
        company,
        street,
        street2,
        city,
        postal_code: postalCode,
      } = this.seller.address

      // TODO: The address should come from the back-end
      // Depending on the country the format could be different.
      // Ticket: NS-676
      return [postalCode, city, street, street2, company]
        .filter(Boolean)
        .join(', ')
    },

    hasAddress() {
      return !isEmpty(this.seller.address)
    },

    showMerchantInfo() {
      return (
        this.seller.isShownMerchantInfo &&
        (this.hasAddress || this.seller.vatNumber || this.seller.siretNumber)
      )
    },

    showBlock() {
      return (
        this.seller.description ||
        this.showMerchantInfo ||
        this.seller.konbini ||
        this.seller.australia
      )
    },
  },
}
